import React, { Component } from "react";
import PropTypes from "prop-types";
import update from 'immutability-helper';
import Step from "./Step";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { CSSTransitionGroup } from 'react-transition-group';

const style = {
  width: "100%"
};

class StepsList extends Component {
  static propTypes = {
    version: PropTypes.object.isRequired,
    steps: PropTypes.array.isRequired,
    templates: PropTypes.array.isRequired,
    smsTemplates: PropTypes.array.isRequired,
    rvmTemplates: PropTypes.array.isRequired,
    campaign: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    handleSave: PropTypes.func.isRequired,
    handleFetch: PropTypes.func.isRequired,
    handleTooltipForPause: PropTypes.func.isRequired,
    rookeryEnabled: PropTypes.bool.isRequired,
    query: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.moveStep = this.moveStep.bind(this);
    this.state = {
      steps: this.props.steps,
      templates: this.props.templates,
      smsTemplates: this.props.smsTemplates,
      rvmTemplates: this.props.rvmTemplates
    };
  }

  moveStep(dragIndex, hoverIndex) {
    const { steps } = this.state;
    const dragStep = steps[dragIndex];
    this.setState(
      update(this.state, {
        steps: {
          $splice: [[dragIndex, 1], [hoverIndex, 0, dragStep]]
        }
      })
    );
    let newSteps = this.state.steps.map((step, i) => {
      step.position = i;
      return step;
    });
    this.props.handleSave(this.props.campaign.id, { steps: newSteps });
  }

  onAddStepClick() {
    let newSteps = this.state.steps;
    newSteps.push({
      id: Math.floor(Math.random() * 100000000 + 1),
      position: newSteps.length,
      delay_value: "1",
      delay_unit: "hours",
      medium: "email"
    });
    this.props.handleSave(this.props.campaign.id, {
      steps: newSteps,
      scrollToBottom: true
    });
  }

  onRemoveStepClick(key) {
    let removed = false;
    let newSteps = [];
    let steps = this.state.steps;
    steps.map((step, i) => {
      if (step.position == key) {
        removed = true;
      } else {
        if (removed == true) {
          step.position = step.position - 1;
        }
        newSteps.push(step);
      }
    });
    this.setState({ steps: newSteps });
    this.props.handleSave(this.props.campaign.id, { steps: newSteps });
  }

  onSaveStep(s) {
    let newSteps = this.state.steps.map((step, i) => {
      if (step.id == s.id) {
        return Object.assign(step, s);
      } else {
        return step;
      }
    });
    this.setState({ steps: newSteps });
    this.props.handleSave(this.props.campaign.id, { steps: newSteps });
  }

  stepList() {
    if (this.state.steps.length == 0) {
      return (
        <div className="p-15 text-center">
          You have no steps. &nbsp;
          <a onClick={this.onAddStepClick.bind(this)} className="link">
            Click here to create one.
          </a>
        </div>
      );
    } else {
      let steps = this.state.steps.map((step, i) => {
        return (
          <Step
            key={step.id}
            index={i}
            id={step.id}
            isNew={step.isNew}
            delayValue={step.delay_value}
            delayUnit={step.delay_unit}
            senders={this.props.campaign.senders}
            rookeryEnabled={this.props.rookeryEnabled}
            medium={step.medium}
            medium_data={step.medium_data}
            emailTemplateId={step.email_template_id}
            smsTemplateId={step.sms_template_id}
            rvmTemplateId={step.rvm_template_id}
            postcardTemplateId={step.postcard_template_id}
            postcard_templates={this.props.campaign.postcard_templates}
            templates={this.props.templates}
            smsTemplates={this.props.smsTemplates}
            rvmTemplates={this.props.rvmTemplates}
            handleSave={this.onSaveStep.bind(this)}
            handleRemove={this.onRemoveStepClick.bind(this)}
            handleFetch={this.props.handleFetch}
            handleTooltipForPause={this.props.handleTooltipForPause}
            moveStep={this.moveStep}
            stepEnabled={this.props.version.status == "Draft"}
            match={this.props.match}
          />
        );
      });
      return steps;
    }
  }

  addStepButton() {
    if (this.props.version.status == "Draft") {
      return (
        <button
          className="btn btn-sm btn-success pull-right add_step_btn"
          onClick={this.onAddStepClick.bind(this)}
        >
          Add Step
        </button>
      );
    }
  }

  showNewWorkflowFromLibraryWarning() {
    if (this.props.query.from_starter_workflow == "true") {
      return (
        <div className="alert alert-warning text-center alert-important-text">
          <strong>IMPORTANT:</strong> Please review the details of every step in
          the workflow to customize it for you and your area. Fields marked with
          parenthesis around them need to be changed manually. Click &apos;Publish&apos;
          when complete.
        </div>
      );
    }
  }

  render() {
    const { steps } = this.state;
    if (!steps) {
      return (
        <CSSTransitionGroup
          transitionName="spinner"
          transitionAppear={true}
          transitionAppearTimeout={500}
        >
          <div className="vertical-center">
            <i className="fa fa-refresh fa-4x fa-spin" />
          </div>
        </CSSTransitionGroup>
      );
    }
    return (
      <DndProvider backend={HTML5Backend}>
        <div className="panel panel-default campaign_steps">
          <div className="panel-body p-0">
            <div className="steps_start">
              Start
              {this.addStepButton()}
            </div>
            {this.showNewWorkflowFromLibraryWarning()}
            <div style={style}>{this.stepList()}</div>
            <div className="steps_end">
              End
              {this.addStepButton()}
            </div>
          </div>
        </div>
      </DndProvider>
    );
  }
}

export default StepsList;
